import React from 'react';
import { Route, Switch } from 'react-router-dom';
import StudentList from './list';
import StudentDetail from './detail';

const Students = () => {
  return (
    <Switch>
      <Route path="/students/list" component={StudentList} />
      <Route path="/students/:id/detail/:ongoing" component={StudentDetail} />
    </Switch>
  );
};
export default Students;
